"use strict";
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.transposeObjectArray = void 0;
/**
 * Transposes an array of objects by converting selected properties into arrays
 * while keeping the remaining properties grouped in a 'rest' array.
 * @template T - The type of objects in the input array
 * @template K - The keys of properties to transpose
 * @param param - the objects, properties, and transposing options
 * @returns An object containing transposed arrays for each selected property
 * @example
 * const objects = [
 *   { id: 1, name: 'John', age: 25 },
 *   { id: 2, name: 'Jane', age: 30 }
 * ]
 * const result = transposeObjectArray({objects, properties: ['id', 'name']});
 * // Returns: {
 * //   id: [1, 2],
 * //   name: ['John', 'Jane'],
 * //   rest: [{age: 25}, {age: 30}]
 * // }
 */
const transposeObjectArray = ({ objects, properties, options = { includeOtherProperties: true }, }) => objects.reduce((acc, item) => {
    const result = { ...acc };
    properties.forEach((prop) => {
        const currentArray = (acc[prop] || []);
        result[prop] = [...currentArray, item[prop]];
    });
    const restObject = {};
    Object.entries(item).forEach(([key, value]) => {
        if (!properties.includes(key)) {
            restObject[key] = value;
        }
    });
    if (options.includeOtherProperties) {
        result.rest = [...(acc.rest || []), restObject];
    }
    return result;
}, {});
exports.transposeObjectArray = transposeObjectArray;
//# sourceMappingURL=transposeObjectArray.js.map